export const GET_USERS = "GET_USERS";
export const ADD_VOTE_TO_USER = "ADD_VOTE_TO_USER";
export const ADD_QUESTION_TO_USER = "ADD_QUESTION_TO_USER";
